import React from "react";
import { Attachment } from "stream-chat-react";
import { CustomCardAttachment } from "./CustomCardAttachment";

const CustomAttachment = (props: any) => {
    return <Attachment {...props} Card={CustomCardAttachment} />;
};

export default CustomAttachment;